import React from "react"
import { Card, CardBody, CardHeader } from "reactstrap"
import { OpportunityListAnyContainer } from "components/opportunities/redux/OpportunityContainers"
import Icon from "components/common/Icon"

const OpportunityCardAnyBasic = () => {
    return (
        <Card>
            <CardHeader>
                <h6>
                    <Icon opportunity />
                    All Opportunities
                </h6>
            </CardHeader>
            <CardBody>
                <OpportunityListAnyContainer />
            </CardBody>
        </Card >
    )
}

export default OpportunityCardAnyBasic
